import globalTheme from '../global'

const Accordion = {
	MuiAccordion: {
		styleOverrides: {
			root: {
				backgroundColor: 'unset',
				borderRight: 0,
				borderLeft: 0,
				borderTop: 0,
				borderColor: globalTheme.palette.grey.light,
				'&::before': {
					display: 'none',
				},
				'&:first-of-type': {
					borderTop: '1px solid',
					borderColor: globalTheme.palette.grey.light,
				},
				'&.Mui-expanded': {
					margin: 0,
				},
			},
		},
	},
	MuiAccordionSummary: {
		styleOverrides: {
			root: {
				padding: '29px 17px 29px 17px',
				margin: 0,
			},
			content: {
				padding: 0,
				margin: 0,
				'&.Mui-expanded': {
					margin: 0,
				},
			},
			expandIconWrapper: {
				color: globalTheme.palette.grey.main,
				'&.Mui-expanded': {
					color: globalTheme.palette.primary.main,
				},
			},
		},
	},
	MuiAccordionDetails: {
		styleOverrides: {
			root: {
				color: globalTheme.palette.grey.main,
				paddingTop: 0,
				paddingBottom: 33,
			},
		},
	},
}

export default Accordion
